import * as Sentry from '@sentry/vue';
import { sdkErrorFingerprint, toSdkError } from '~/utils/sdkError';
import { toSentryUser } from '~/utils/sentryConfig';

const useSentry = () => {
   // Only the id is sent. Callers hold the full profile, so the payload is narrowed here
   // rather than trusting every call site to omit PII.
   const setUser = (user: { id: string | number } | null) => {
      Sentry.setUser(toSentryUser(user));
   };
   // Reports a failed Zoom SDK call as a real Error. The fingerprint groups by operation
   // and SDK error type (and reason when it is a constant), so different failures do not
   // collapse into one issue.
   const captureSdkError = (operation: string, error: unknown) => {
      const sdkError = toSdkError(error, operation);
      Sentry.captureException(sdkError, {
         tags: { zoom_operation: operation },
         fingerprint: sdkErrorFingerprint(operation, sdkError),
      });
   };
   return { setUser, captureSdkError };
};
export default useSentry;
